<template>
  <div>
    <ul class="el-upload-list el-upload-list--picture-card"><!--  v-if="companySign" -->
      <li tabindex="0" v-for='(file, index) in photoListCopy' :key="index" class="el-upload-list__item is-ready">
        <div>
          <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" >
          <span class="el-upload-list__item-actions">
            <span class="el-upload-list__item-preview" style="margin:0" @click="handlePreview(file)" >
              <i class="el-icon-zoom-in"></i>
            </span>
            <span v-if="!disabled" class="el-upload-list__item-delete" style="margin:0" @click="handleRemove(file)" >
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </div>
      </li>
    </ul>
    <!-- <ul class="el-upload-list el-upload-list--picture-card" v-else>
      <li tabindex="0" v-for='(file, index) in photoListCopy' :key="index" class="el-upload-list__item is-ready">
        <div>
          <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" >
        </div>
      </li>
    </ul> -->
    <el-dialog :visible.sync="dialogVisible" title="图片预览" :modal-append-to-body='false' :append-to-body='true' :close-on-click-modal="false" width="75%">
      <img width="100%" :src="dialogImageUrl" alt="">
      <div class="foot">
        <el-button :disabled="disabled" @click="copySign" round type="primary">保存笔迹</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'cPhotoWall',

    props: {
      photoList:{
        type:Array,
      },
      companySign:{
        type: Boolean,
        default: true,
      },
      disabled: [Boolean,Number],//禁用
    },

    data () {
      return {
        photoListCopy:[{url:`${process.env.BASE_URL}favicon.ico`,}],//{name: , id: , type:  url: }
        dialogImageUrl:'',
        dialogVisible:false,
      }
    },

    components: {
      
    },

    created() {
      
    },

    mounted() {
      
    },

    methods: {
      handlePreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
        if (event) event.preventDefault()
      },
      handleRemove(file) {
        let _that = this
        let deleteIndex=0;
        if (event) event.preventDefault()
        this.$confirm("删除后不可恢复", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(async () => {
          this.photoListCopy = this.photoListCopy.filter( item => item.url != file.url)
          this.$emit('changeValue',this.photoListCopy)
        })
      },
      copySign(){
				this.$axios.get(this.dialogImageUrl,{ responseType: "blob"})
				.then(res => {
					if(res.data instanceof Blob){
						const reader = new FileReader()
						reader.readAsDataURL(res.data)
						reader.onload = () =>{
							//base64
							let userId = sessionStorage.getItem('userId')
							this.$axios.post('/dform/inForm/getBaseQz', {userId})
							.then((res) => {
								if(res.data.data){
									return this.$axios.post('/dform/inForm/saveBaseQz',{ID:res.data.data.id,userId,base64Img:reader.result})
								}else{
									return this.$axios.post('/dform/inForm/saveBaseQz',{ID:'',userId,base64Img:reader.result})
								}
							},() => {
							}).then((res) =>{
								if(res.data.code){
									sessionStorage.setItem('personalSignFile',reader.result)
								}
							},() => {
							})
						}
					}
				})
      },
    },

    computed: {
      
    },

    watch: {
      photoList:{
        handler(val,oldVal){
          if(val.length){
              this.photoListCopy = JSON.parse(JSON.stringify(val))
          }
        },
        deep: true,
        immediate: true,
      }
    },

  }
</script>

<style>
.el-upload-list__item-delete{
  margin: 0;
}
</style>
